module.exports = __webpack_public_path__ + "img/driver-img.d43d2d29.png";